<template>
  <div :class="cardClass"
    class="flex w-fit items-center space-x-4 rounded-md border px-4 py-2 font-medium shadow-sm transition-all duration-300">
    <component :is="icon" :class="iconClass" class="h-6 w-6 shrink-0 fill-current" />

    <slot name="before-message"></slot>
    <span :class="messageClass" class="whitespace-pre-wrap" v-html="message"></span>
    <slot name="after-message"></slot>
  </div>
</template>

<script>
const config = {
  warning: {
    icon: 'SolidExclamationCircleIcon',
    cardClass: 'bg-yellow-50 border-yellow-400',
    iconClass: 'text-yellow-700/90',
    messageClass: 'text-yellow-700/90',
  },
  info: {
    icon: 'SolidInformationCircleIcon',
    cardClass: 'bg-blue-50 border-blue-300',
    iconClass: 'text-blue-700',
    messageClass: 'text-blue-700',
  },
  error: {
    icon: 'SolidXCircleIcon',
    cardClass: 'bg-red-50 border-red-300',
    iconClass: 'text-red-700',
    messageClass: 'text-red-700',
  },
  success: {
    icon: 'SolidXCheckCircleIcon',
    cardClass: 'bg-green-50 border-green-300',
    iconClass: 'text-green-700',
    messageClass: 'text-green-700',
  },
}

export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },

  computed: {
    icon() {
      return config[this.type].icon
    },
    cardClass() {
      return config[this.type].cardClass
    },
    iconClass() {
      return config[this.type].iconClass
    },
    messageClass() {
      return config[this.type].messageClass
    },
  },
}
</script>
